// Signature Experiences — Lumière Entertainment
// Each experience is a self-contained luxury event concept with detailed
// inclusions and "perfect for" audience tags.

export const EXPERIENCES = [
  {
    num: "01",
    slug: "fly-me-to-the-moon",
    name: "Fly Me to the Moon",
    subtitle: "Luxury Wedding Experience",
    desc:
      "A romantic celebration where the couple takes center stage on a handcrafted crescent moon, surrounded by celestial lighting, live music and immersive theatrical moments.",
    includes: [
      "Moon stage installation",
      "Floating welcome performers",
      "Live vocals & orchestra",
      "Custom lighting design",
      "Luxury dinner styling",
      "Fireworks finale",
    ],
    perfect: "Destination Weddings · Luxury Hotels · Private Estates",
    image:
      "/generated/concept-fly-me-to-the-moon.jpg",
  },
  {
    num: "02",
    slug: "white-party",
    name: "White Party",
    subtitle: "Luxury Summer Celebration",
    desc:
      "A sophisticated all-white experience inspired by Mediterranean elegance, sunset cocktails and glamorous entertainment.",
    includes: [
      "White décor styling",
      "White dress code",
      "Saxophone & DJ",
      "White aerial performers",
      "Champagne tower",
      "White floral installations",
    ],
    perfect: "Beach Clubs · Hotels · Villas · Yacht Events",
    image: "/generated/white-party-1.jpg",
  },
  {
    num: "03",
    slug: "lake-doxa",
    name: "Lake Doxa",
    subtitle: "Autumn Destination Wedding",
    desc:
      "A poetic wedding experience inspired by forests, lakes and warm autumn colors, where nature becomes the stage.",
    includes: [
      "Forest ceremony",
      "Candlelit dinner",
      "Live strings",
      "Autumn styling",
      "Woodland entertainment",
      "Seasonal floral design",
    ],
    perfect: "Destination Weddings",
    image:
      "/generated/concept-lake-doxa.jpg",
  },
  {
    num: "04",
    slug: "wild-night",
    name: "Wild Night",
    subtitle: "Luxury Fashion Brand Experience",
    desc:
      "Inspired by haute couture houses and the untamed beauty of nature, this immersive experience transforms the venue into a cinematic jungle of luxury.",
    includes: [
      "Sculptural animals",
      "Fashion performances",
      "Live musicians",
      "Projection mapping",
      "Immersive lighting",
      "Couture hostesses",
    ],
    perfect: "Fashion Brands · Luxury Houses · Editorial Events",
    image:
      "/generated/concept-wild-night.jpg",
  },
  {
    num: "05",
    slug: "disco-couture",
    name: "Disco Couture",
    subtitle: "Fashion Experience",
    desc:
      "A glamorous Studio 54 inspired fashion event combining runway, live entertainment and immersive disco styling.",
    includes: [
      "Disco runway",
      "Fashion show",
      "Mirror installations",
      "Roller performers",
      "Live singers",
      "LED dance show",
    ],
    perfect: "Fashion Brands · Shopping Centers · Product Launches",
    image: "/generated/disco-80s-hero.png",
  },
  {
    num: "07",
    slug: "bollywood-celebration",
    name: "Bollywood Celebration",
    subtitle: "Luxury Indian Wedding",
    desc:
      "A spectacular celebration inspired by Bollywood with vibrant colours, dance, music and royal décor.",
    includes: [
      "Bollywood dancers",
      "Live percussion",
      "Royal entrance",
      "Floral installations",
      "Sangeet entertainment",
      "Traditional & modern fusion acts",
    ],
    perfect: "Indian Weddings · Luxury Hotels",
    image:
      "/generated/concept-bollywood-celebration.jpg",
  },
  {
    num: "08",
    slug: "sea-nymphs",
    name: "Sea Nymphs Yacht Experience",
    subtitle: "Myth · Beauty · Freedom",
    desc:
      "An immersive sensory journey inspired by the mythical sea nymphs. A luxury yacht party where ocean goddesses emerge from the sea, dance with the elements of nature and celebrate life in perfect harmony.",
    highlights: [
      "Aerial & Water Performances",
      "Live DJ & Ethereal Music",
      "Luxury Dining & Signature Cocktails",
      "Ocean Themed Decor & Ambience",
      "Starlit Dance Party",
    ],
    entertainment: [
      "Nymph Entrance — Dramatic appearance from the sea to welcome guests",
      "Water Ballet — Synchronized swimming and aquatic choreography",
      "Aerial Nymphs — Flying dancers in silks and hoops from the masts",
      "Live Music & DJ — Ethereal violin and DJ sets with ocean vibes",
      "Fire & Light Show — Enchanting elements under the stars",
    ],
    decor: [
      "Ocean palette: teal, aqua, pearl, gold",
      "Flowing fabrics, shells, corals and pearls",
      "Underwater lighting & projections",
      "Floating candles and dreamy table design",
    ],
    cocktails: [
      "Signature cocktails inspired by the sea",
      "Fine dining with Mediterranean flavors",
      "Exquisite presentation & luxury service",
    ],
    atmosphere: [
      "Ambient lighting & projections",
      "Performers roaming the deck",
      "Immersive sound of the ocean and waves",
    ],
    chapters: [
      {
        title: "1. Sea Nymphs — Mystagogic Reception",
        text:
          "The dancers appear dressed in white veils and silver masks, like sea nymphs emerging from the abyss. They move slowly, ritualistically, either in line or side by side, with synchronized movements that exude mystery. Their presence acts as a rite of welcome for the guests.",
        image: "/generated/sea-nymphs-story-1.jpg",
      },
      {
        title: "2. Ocean Spirits — Fluid Movement and Sensation",
        text:
          "Without the veils and masks, the dancers return with silver face & body painting and wet, slicked-back hair. The costumes are decorated with pearls, shells and marine elements. The movement is undulating, airy and utterly sensual. The light accentuates the reflections from the ornaments, creating a mesmerizing illusion of flowing water.",
        image: "/generated/sea-nymphs-story-2.jpg",
      },
      {
        title: "META MUSES — The Other Shore",
        text:
          "Three dancers, three transformations — a passage from mysticism to sensual flow and finally to explosive futuristic energy. An immersive experience designed for private moments of high aesthetics, where each look reveals a new version of the female presence — mysterious, fluid, electrifying.",
        image: "/generated/sea-nymphs-story-3.jpg",
      },
    ],
    epilogue:
      "As the sun sets, the sea comes alive. Nymphs rise, dance and celebrate freedom in an unforgettable night of luxury, music and ocean magic. Be the legend. Live the myth.",
    includes: [
      "Mermaid & nymph performers",
      "Aerial silk & hoop shows",
      "Water choreography & synchronised swimming",
      "Live violin & DJ",
      "Ocean-themed styling & floral installations",
      "Signature cocktails & fine dining",
      "Champagne welcome",
      "Fire & light finale",
    ],
    perfect:
      "Luxury Yachts · Private Islands · Summer Events · Luxury Brands · VIP Guests · Exclusive Events · Product Launches · Celebrations",
    image: "/generated/sea-nymphs-yacht-hero.jpg",
    gallery: [
      "/generated/sea-nymphs-yacht-hero.jpg",
      "/generated/sea-nymphs-story-1.jpg",
      "/generated/sea-nymphs-story-2.jpg",
      "/generated/sea-nymphs-story-3.jpg",
    ],
  },
  {
    num: "09",
    slug: "sky-performance",
    name: "Sky Performance",
    subtitle: "Luxury Brand Activation",
    desc:
      "A breathtaking aerial performance where dancers suspended above the audience reveal the brand through movement, light and emotion.",
    includes: [
      "Aerial choreography",
      "Brand reveal",
      "Projection mapping",
      "Original soundtrack",
      "Interactive lighting",
      "Grand finale",
    ],
    perfect: "Luxury Brands · Automotive · Watches · Jewellery",
    image:
      "/generated/concept-sky-performance.jpg",
  },
  {
    num: "10",
    slug: "editorial-beauty",
    name: "Editorial Beauty Experience",
    subtitle: "Beauty Brand Campaign",
    desc:
      "A cinematic beauty campaign where music, theatre and haute couture merge into an unforgettable live editorial experience.",
    includes: [
      "Live performers",
      "Musical storytelling",
      "Couture costumes",
      "Beauty installations",
      "Editorial styling",
      "Luxury photography moments",
    ],
    perfect: "Beauty · Cosmetics · Fragrance · Fashion",
    image: "/generated/concept-luxury-brand-editorial.mp4",
    isVideo: true,
  },
  {
    num: "11",
    slug: "creative-luxury-bars",
    name: "Creative Luxury Bars",
    subtitle: "Interactive Bar Experiences",
    desc:
      "Bars designed as immersive installations, turning every cocktail into an unforgettable moment. The bar becomes part of the visual identity of the event.",
    includes: [
      "Signature Cocktail Bars",
      "Champagne Towers",
      "Wellness & Mocktail Bars",
      "Floral Bar Styling",
      "Interactive Mixology",
      "Mobile Luxury Bars",
      "Themed Bar Concepts",
      "Celebration Rituals",
    ],
    perfect:
      "Luxury Weddings · Brand Launches · Hotels · Fashion Events · Private Celebrations",
    image:
      "/generated/mockup-bar-services.png",
  },
  {
    num: "12",
    slug: "signature-installations",
    name: "Signature Installations",
    subtitle: "Bespoke Artistic Installations",
    desc:
      "Large-scale artistic installations designed to define the atmosphere of every event and become its most photographed moment.",
    includes: [
      "Welcome Installations",
      "Floral Sculptures",
      "Statement Backdrops",
      "Hanging Floral Ceilings",
      "Candle & Light Installations",
      "Lounge Styling",
      "Entrance Experiences",
      "Bespoke Props",
    ],
    perfect:
      "Luxury Weddings · Hotels · Fashion Events · Destination Events · Brand Experiences",
    image:
      "/generated/concept-signature-installations.jpg",
  },
  {
    num: "12B",
    slug: "creative-costumes",
    name: "Creative Costumes",
    subtitle: "Bespoke Costume Design & Styling",
    desc:
      "Editorial-grade costumes tailored for each concept — from show-stopping headpieces to fabric sculptures that move with the performers. Every costume is designed in our atelier and adapted to the palette, lighting and flow of your night.",
    includes: [
      "Bespoke Show Costumes",
      "Feather & Plume Headpieces",
      "LED & Illuminated Costumes",
      "Aerial Silk & Hoop Wardrobe",
      "Themed Character Costumes",
      "Living Statue Bodypaint & Wear",
      "Bridal Editorial Looks",
      "Hostess & Roaming Performer Styling",
      "Cultural & Historical Reproductions",
      "Brand-branded Performance Wear",
    ],
    perfect:
      "Luxury Weddings · Brand Activations · Fashion Shows · Hotels · Editorial Campaigns · Themed Galas",
    image: "/generated/tribal-show.jpg",
  },
  {
    num: "12C",
    slug: "creative-luxury-catering",
    name: "Creative Luxury Catering & Themed Decoration Props",
    subtitle: "Bespoke Catering Concepts & Statement Props",
    desc:
      "Editorial catering scenography and themed decoration props designed as part of the event's visual identity. From welcome walls and signature displays to food stations, dessert tables and photogenic corners that become the highlight of the night.",
    includes: [
      "Themed Welcome Walls & Photo Moments",
      "Signature Food & Grazing Stations",
      "Luxury Dessert Tables & Sweet Displays",
      "Curated Prop Styling & Set Design",
      "Neon & Signage Statement Pieces",
      "Themed Escort & Seating Displays",
      "Sensory Table Scaping",
      "Champagne & Bar Prop Integration",
      "Bespoke Themed Backdrops",
      "Editorial Floral & Prop Combinations",
    ],
    perfect:
      "Luxury Weddings · Brand Launches · Milestone Celebrations · Themed Galas · Hotels · Destination Events",
    image: "/generated/mockup-decoration-props.png",
  },
  {
    num: "13",
    slug: "sicilian-dolce-vita",
    name: "Sicilian Dolce Vita",
    subtitle: "Mediterranean Celebration Experience",
    desc:
      "A joyful celebration inspired by the timeless charm of Southern Italy. Lemons, handcrafted ceramics, live Italian music and theatrical hospitality create a vibrant Mediterranean atmosphere.",
    includes: [
      "Sicilian Welcome Experience",
      "Lemon & Citrus Installations",
      "Italian Live Music",
      "Dolce Vita Hostesses",
      "Amalfi-inspired Styling",
      "Mediterranean Bar Experience",
      "Vespa & Photo Moments",
      "Italian Street Food Corners",
    ],
    entertainment: [
      "Italian singers",
      "Mandolin & accordion musicians",
      "Mambo Italiano dancers",
      "Living statues",
      "Pasta-making live station",
      "Limoncello ritual",
      "Vespa photo performers",
    ],
    perfect:
      "Destination Weddings · Luxury Hotels · Italian Brands · Summer Events · Private Villas",
    image: "/generated/sicilian-dolce-3.jpg",
  },
  {
    num: "14",
    slug: "bachelorette-experience",
    name: "Bachelorette Experience",
    subtitle: 'A Celebration Before "I Do"',
    desc:
      "An elevated bachelorette experience designed for stylish brides-to-be who want more than just a party. Every detail is curated to create unforgettable moments — from luxury styling and bespoke décor to immersive entertainment, signature cocktails and personalised experiences. Whether it's a beach villa, private yacht, luxury hotel or destination resort, we transform the celebration into a one-of-a-kind event that feels cinematic, elegant and deeply personal.",
    includes: [
      "Luxury themed styling & décor",
      "Welcome cocktails & champagne moments",
      "Live music, DJs & entertainment acts",
      "Interactive cocktail or beauty bars",
      "Floral installations & photo moments",
      "Wellness rituals & spa experiences",
      "Sunset dinners & private parties",
      "Custom gifts, branding & personalised details",
    ],
    perfect:
      "Luxury Villas · Destination Weddings · Private Yachts · Five-star Resorts · Bride Tribes",
    image:
      "/generated/concept-bachelorette-experience.jpg",
  },
  {
    num: "15",
    slug: "the-last-sunset-before-i-do",
    name: 'The Last Sunset Before "I Do"',
    subtitle: "Signature Bachelorette Editorial",
    desc:
      "A luxury editorial bachelorette experience next to the pool or the sea, designed like a magazine photo shoot and not like a classic bridal party. All the guests wear monochrome looks in white, nude or champagne, while the bride stands out with a couture outfit.",
    arrival: [
      'Giant "Bride to Be" shell installation',
      "Pearl & shell styling",
      "White orchids",
      "Candle styling",
      "Personalised welcome cocktails",
      "Champagne tower",
    ],
    installations: [
      "Giant seashell photo point",
      'Mirror installation ("Meet the Future Mrs...")',
      "Pearl bar",
      "Oyster & champagne station",
      "Luxury picnic lounge",
      "Floating floral pool styling",
      "Sunset photo set",
    ],
    entertainment: [
      "Champagne fairies",
      "White violin performance",
      "Saxophone with DJ",
      "Fashion-style dancers",
      "Live painter illustrating the bride",
      "Content creator filming cinematic reels",
      "Golden hour drone show",
    ],
    bar: [
      "Signature bridal cocktails",
      "Oyster & champagne pairing",
      "White dessert station",
      "Coconut & tropical mocktail bar",
      "Personalised cocktails named after the bride",
    ],
    styling: {
      palette: "White · Pearl · Champagne · Sand · Ivory · Gold",
      flowers: "White orchids · Hydrangeas · Baby roses · Gypsophila",
      materials: "Linen · Shells · Pearls · Natural stone · Glass",
    },
    perfect:
      "Luxury Hotels · Beach Clubs · Destination Weddings · Luxury Villas · Yacht Celebrations · Bridal Weekends",
    image:
      "/generated/concept-last-sunset.jpg",
  },
  {
    num: "16",
    slug: "wellness-sound-experience",
    name: "Wellness & Sound Experience",
    subtitle: "Luxury Wellness Ritual",
    desc:
      "A multisensory wellness journey designed to reconnect body, mind and atmosphere through movement, sound and mindful luxury.",
    includes: [
      "Sunset Yoga",
      "Breathwork Sessions",
      "Sound Healing Ceremony",
      "Live Handpan & Ambient Music",
      "Healthy Brunch or Dinner",
      "Fresh Juice & Wellness Bar",
      "Aromatherapy",
      "Meditation Spaces",
    ],
    perfect:
      "Luxury Hotels · Wellness Resorts · Corporate Retreats · Luxury Communities · Destination Events",
    image:
      "/generated/concept-wellness-sound.jpg",
  },
  {
    num: "17",
    slug: "mediterranean-grazing-lounge",
    name: "Mediterranean Grazing & Lounge",
    subtitle: "Social Dining Experience",
    desc:
      "A relaxed yet refined Mediterranean gathering where beautiful grazing stations, signature cocktails and live music create effortless luxury and meaningful connection.",
    includes: [
      "Luxury Grazing Tables",
      "Mediterranean Cuisine",
      "Signature Cocktails",
      "Lounge Furniture Styling",
      "Live Acoustic Music",
      "Saxophone & DJ",
      "Floral Styling",
      "Sunset Lighting",
    ],
    perfect: "Luxury Villas · Private Terraces · Hotels · Yachts",
    image:
      "/generated/concept-grazing-lounge.jpg",
  },
  {
    num: "18",
    slug: "minoan-crete",
    name: "Minoan Crete",
    subtitle: "The Palace of Knossos",
    desc:
      "Inspired by the elegance of Minoan Crete, this destination wedding experience celebrates the island's rich heritage through contemporary luxury. Earth tones, handcrafted ceramics, olive branches, Cretan florals and architectural references to Knossos create a timeless atmosphere.",
    includes: [
      "Knossos-inspired ceremony styling",
      "Live lyre & Cretan musicians",
      "Contemporary Minoan dancers",
      "Olive oil & wine tasting",
      "Ancient-inspired tablescapes",
      "Fire ceremony at sunset",
      "Artisan workshops & local gastronomy",
    ],
    perfect:
      "Destination Weddings · Luxury Hotels · Private Estates · Cultural Celebrations",
    image:
      "/generated/concept-minoan-crete.jpg",
  },
  {
    num: "19",
    slug: "roman-empire",
    name: "Roman Empire",
    subtitle: "La Dolce Roma",
    desc:
      "A grand Roman-inspired celebration featuring marble aesthetics, sculptural décor, candlelit banquets and imperial elegance. Classical architecture meets contemporary luxury entertainment for an unforgettable destination wedding.",
    includes: [
      "Roman columns & sculptural installations",
      "Living statues & Roman performers",
      "String quartet & opera moments",
      "Imperial banquet styling",
      "Luxury floral compositions",
      "Champagne procession",
      "Dramatic candlelight dinner",
    ],
    perfect: "Luxury Weddings · Historic Venues · Villas · Grand Hotels",
    image:
      "/generated/concept-roman-empire.jpg",
  },
  {
    num: "20",
    slug: "charity-community-festivals",
    name: "Charity & Community Festivals",
    subtitle: "Purpose-Driven Celebrations",
    desc:
      "Large-scale festivals designed to bring communities together, celebrate culture and support important causes — with the same cinematic quality as our luxury private events.",
    includes: [
      "Community stages & performances",
      "Charity partner activations",
      "Local cultural acts",
      "Family-friendly entertainment",
      "Curated food & artisan markets",
      "Sponsor experience zones",
    ],
    perfect:
      "Charities · Municipalities · Non-profits · Community Organisations",
    image:
      "/generated/concept-charity-festivals.jpg",
  },
];
